export default __webpack_public_path__ + "static/media/related_work_icon.72d88a13.svg";